module.exports = __webpack_public_path__ + "assets/img/Edito_Olivier-Lecler_cover.2068d6a4-ps.jpg";